import { resolveAsImage } from '../../resolvers'
import classNames from 'classnames'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { ReactNode } from 'react'
import { GatsbyResolvedAsset } from '../../types/image'
import Heading from '../Heading/Heading'
import styles from './GreyBox.module.scss'

export type GreyBoxProps = {
  title: ReactNode
  children: ReactNode
  footNote?: string
  image?: GatsbyResolvedAsset
  className?: string
}

export default function GreyBox(props: GreyBoxProps) {
  const { title, children, footNote, image: imageData, className } = props
  const image = imageData && resolveAsImage(imageData)
  return (
    <div className={classNames(styles.container, className)}>
      {image && (
        <GatsbyImage
          image={image}
          alt=""
          role="presentation"
          className={styles.image}
        />
      )}
      <Heading level={2} type="lg" className={styles.title}>
        {title}
      </Heading>
      <div className={styles.main}>
        <div className={styles.content}>{children}</div>
        {footNote && (
          <div
            className={styles.footnote}
            dangerouslySetInnerHTML={{ __html: footNote }}
          />
        )}
      </div>
    </div>
  )
}
